import styled from '@emotion/styled'
import { MultiButton, MultiButtonProps } from './MultiButton'
import * as constants from 'view/styles/constants'

export const IconButton = styled(MultiButton)`
  width: 24px;
  height: 24px;
  border: none;
  color: ${(props: MultiButtonProps) => (props.disabled ? constants.CORE_PRIMARY_3 : constants.CORE_PRIMARY_7)};
  background: transparent;
`
